import { Injectable } from '@angular/core';
import { TransitionService, Transition } from '@uirouter/angular';
import { ShelvableStateDeclaration } from '../states'
import { ShelvableBackend } from '../services/ShelvableBackend/ShelvableBackend'
import { Meta, Title } from '@angular/platform-browser';
import { GoogleData } from '../services/GoogleData/GoogleData';
import { BehaviorSubject, Subscription, Observable } from 'rxjs'

export class PageMetadataService {

    static displayPriority:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    static isViewingOwnLibrary:Observable<boolean>;

    public static initialise(transitionService:TransitionService, shelvableBackend:ShelvableBackend, metaService:Meta, titleService:Title, googleData:GoogleData) {
        var isViewingOwnLibrary = new BehaviorSubject<boolean>(false);
        this.isViewingOwnLibrary = isViewingOwnLibrary.asObservable();

        window.setPriorityDisplay = function(state) {
            PageMetadataService.displayPriority.next(state);
        }
        var subscriptions:Subscription[] = [];
        transitionService.onSuccess({}, (transition:Transition) => {
            while (subscriptions.length > 0) subscriptions.pop().unsubscribe();

            var state = <ShelvableStateDeclaration> transition.targetState().state();

            (async () => {
                if ((state.name === 'user' || state.name === 'shelf') && transition.params().username) {
                    var userId = await shelvableBackend.getUserId(transition.params().username);
                    isViewingOwnLibrary.next(userId === shelvableBackend.loggedInUserId.getValue())
                } else {
                    isViewingOwnLibrary.next(false);
                }
            })()

            if (state.pageMetadata) {
                var observables = state.pageMetadata(transition.params(), shelvableBackend, googleData);
                
                subscriptions.push(observables.breadcrumbs.subscribe((breadcrumbs) => {
                    document.getElementById('breadcrumbs').innerText = breadcrumbs;
                }, (error) => {
                    console.error(error);
                    document.getElementById('breadcrumbs').innerText = '';
                }));

                subscriptions.push(observables.title.subscribe((title) => {
                    titleService.setTitle(title);
                }, (error) => {
                    console.error(error);
                    titleService.setTitle('Shelvable.');
                }));

                subscriptions.push(observables.metaRobots.subscribe((metaRobots) => {
                    metaService.updateTag({name: 'robots', content: metaRobots.join(',')}, 'name=robots');
                }, (error) => {
                    console.error(error);
                    metaService.updateTag({name: 'robots', content: 'noindex'}, 'name=robots');
                }));

                subscriptions.push(observables.description.subscribe((description) => {
                    metaService.updateTag({name: 'description', content: description}, 'name=description');
                }, (error) => {
                    console.error(error);
                    metaService.updateTag({name: 'description', content: ''}, 'name=description');
                }));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./web/static/services/PageMetadataService.ts